// extracted by mini-css-extract-plugin
export default {"wrapper":"LgSNHeEOkub_DL5aLt7x","inner":"dqlgOCEt1gza5ug9jpHk"};